import React, { DragEvent as ReactDragEvent, useCallback } from 'react';

import { createPortal } from 'react-dom';

interface ILandingZone {
    hidden: boolean;
    onDragLeave: () => void;
    onFileAttached: (files: File[]) => void;
}

export const LandingZone: React.FC<ILandingZone> = (props) => {
    const onDrop = useCallback(
        (e: ReactDragEvent) => {
            props.onFileAttached(Array.from(e.dataTransfer.files));
            props.onDragLeave();
        },
        [props.onFileAttached]
    );

    return createPortal(
        <div
            aria-label={'landing-zone'}
            onDragLeave={() => props.onDragLeave()}
            onDrop={onDrop}
            style={{
                display: props.hidden ? 'none' : undefined,
                width: '100%',
                height: '100%',
                zIndex: 100,
                position: 'absolute',
                backgroundColor: 'gray',
                opacity: '50%'
            }}
        />,
        document.querySelector('#root') ?? document.body
    );
};
